import { createIcon } from '../createIcon';

export const VenusIconConfig = {
  name: 'VenusIcon',
  height: 512,
  width: 288,
  svgPath: 'M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const VenusIcon = createIcon(VenusIconConfig);

export default VenusIcon;